import { Badge } from 'react-bootstrap';
import { SECTION_TITLE_STYLE, BADGE_SMALL_STYLE } from './styles';

interface SectionHeaderProps {
  readonly title: string;
  readonly count?: number;
}

export const SectionHeader = ({ title, count }: SectionHeaderProps) => (
  <div className="d-flex align-items-center justify-content-between mb-3">
    <small className="text-muted text-uppercase" style={SECTION_TITLE_STYLE}>
      {title}
    </small>
    {count !== undefined && (
      <Badge bg="secondary" style={BADGE_SMALL_STYLE}>
        {count}
      </Badge>
    )}
  </div>
);

